/// <reference path="../../app.ts" />
namespace Cfnc {
    interface ICfncCountries extends ng.IDirective {

    }


    interface ICfncCountriesScope extends ng.IScope {
        mode: string;
        modelValue: any;
        placeholder: string;
        maxLength: number;
        selected: any;
        multiDisplay: Array<any>;
        countries: Array<any>;
        countryChanged: (newValue) => void;
        multiAdd: (item, model) => void;
        multiRemove: (item, model) => void;
    }

    class CfncCountries implements ICfncCountries {
        static directiveId: string = "cfncCountries";
        restrict: string = "E";
        replace: boolean = true;
        scope: any = {
            mode: "@type", //types: display, select
            modelValue: "=",
            placeholder: "@",
            maxLength: "="
        };

        templateUrl: string = "/app/directives/cfncCountries/cfncCountries.html";

        constructor(private addressService: IAddressService) {
        }

        link = (scope: ICfncCountriesScope, element, attrs) => {
            if (scope.mode == "multiSelect") {
                scope.modelValue = scope.modelValue || [];
            }

            if (scope.mode == "multiSelect") {
                scope.$watch("modelValue", (newValue, oldValue) => {
                    if (angular.isDefined(attrs.maxLength) && attrs.maxLength < scope.modelValue.length) {
                        scope.modelValue = oldValue;
                    }
                });
            }


            scope.countryChanged = (newValue): void => {
                scope.modelValue = newValue.value;
            };


            scope.countries = this.addressService.countryList;


            scope.$watch("modelValue", (newValue, oldValue) => {
                if (Array.isArray(scope.modelValue)) {
                    scope.multiDisplay = [];
                    scope.modelValue.forEach((item) => {
                        var selected = _.find(scope.countries, (c: any) => {
                            return c.value == item;
                        });
                        if (selected) {
                            scope.multiDisplay.push(selected);
                        }
                    });


                }
                else {
                    scope.selected = _.find(scope.countries, (c: any) => {
                        return c.value == scope.modelValue;
                    }) || {
                            name: "",
                            value: null
                        };
                }
            });
        }
    }


    angular.module("app").directive(CfncCountries.directiveId, ["addressService", (addressService: IAddressService) =>
        new CfncCountries(addressService)
    ]);
}